<app-error-page
  [code]="401"
  [title]="'ERROR_PAGES.UNAUTHORIZED' | translate"
  [message]="'ERROR_PAGES.UNAUTHORIZED_MESSAGE' | translate"
  [loginPageBtn]="true"
></app-error-page>
